import editorTranslations from './editor/fr';
import settingsTranslations from './settings/fr';

export default {
    pages: {
        feedback: 'Feedback',
        disclaimer: 'Disclaimer',
        glossary: 'Aide',
    },
    home: {
        infoBanner:
            "Nous modifierons la procédure d'inscription pour werk-material.online dans les jours prochains. Veuillez consulter l'e-mail que vous avez reçu récemment de notre part.",
        title: "Enfin en ligne: coûts d'ouvrage fiables pour toutes les catégories architecturales!",
        lead: 'Vous êtes à la recherche de valeurs et de données référentielles fiables pour tous les types de constructions? Faites confiance à la nouvelle banque de données en ligne werk-material.online. Vous trouverez ici des valeurs chiffrées et des méthodes statistiques pratiques pour le secteur suisse de la construction - simple, transparent et sans faille.',
        segments: {
            data: {
                title: 'Des données de première qualité pour une base solide',
                lead: "CRB développe les standards méthodiques et référentiels du secteur suisse de la construction et de l'immobilier. Classés par types d'ouvrages et Code des coûts de la construction (CFC, eCCC-Bât et eCCC-GC), ils permettent à la fois un calcul des coûts fiable, une description exacte des ouvrages et la rationalisation des processus. werk-material régulièrement publié par werk, bauen + wohnen, est tout aussi utile. De précieuses données concernant toutes les catégories architecturales y sont rassemblées depuis une période inégalée. Tous les ouvrages décrits ont été sélectionnés par la rédaction suivant des critères stricts de qualité. C'est sans doute aussi pour cela que werk, bauen + bauen constitue la référence absolue de la culture constructive suisse.",
            },
            analysis: {
                title: "Instruments d'analyse intelligents et quantité de données sans pareil",
                lead: "Peu importe votre objectif, qu'il s'agisse de l'étude attentive d'un ouvrage ou d'obtenir une vue générale: la combinaison de différentes perspectives chiffrées éclaire toutes les catégories architecturales. Avec des jeux de données enrichis chaque année de 20 ouvrages depuis 1982, werk-material.online offre une ampleur et une profondeur uniques. Elles ont été collectées par werk, bauen + wohnen avec des valeurs de l'Office fédérale de la statistique et complétées par d'autres ouvrages provenant de la banque de données du CRB.",
            },
            architecture: {
                title: "Histoire de l'architecture suisse en complément",
                lead: "werk-material.online offre par ailleurs un formidable aperçu de l'architecture suisse, puisque le site associe données et documentation complète sur les ouvrages. La comparaison chiffrée d'ouvrages montre ce qu'il faut pour établir des standards et des différences dans la culture constructive suisse.",
            },
        },
        'want-access': 'Souhaitez-vous avoir accès à werk-material.online?',
        'register-here': 'Inscrivez-vous ici!',
        'register-buy': 'Enregistrement & Achats',
    },
    register: {
        title: 'Bienvenue sur',
        'now-order-chargeable': 'Commandez dès à présent',
        'invoice-order': 'Règlement sur facture',
        'checking-and-delivery':
            'Après réception de votre commande, vos données seront vérifiées et une facture vous parviendra par voie postale dans la semaine qui suit. Votre abonnement est automatiquement prolongé après une année.',
        register: 'Inscrivez-vous',
        'login-info':
            "Vous nécessitez un compte pour acheter les produits que vous avez sélectionnés. Veuillez vous enregistrer et revenez sur cette page après vous être enregistré.<br/>Si vous disposez déjà d'un compte, veuillez vous connecter. Vous serez ensuite redirigé vers cette page.",
        order: {
            title: 'Sélectionner le(s) produit(s)',
            discount: {
                title: 'Rabais',
                'new-customer': 'Nouveau client',
                'member-crb': 'Membre CRB',
                'member-sia': 'Membre SIA',
                'subscriber-work-bauen-und-wohnen': 'Abonné-e-s werk, bauen + wohnen',
                'discount-code': 'Code de rabais',
            },
            'order-summary': 'Aperçu de la commande',
            'annual-fee': 'Redevance annuelle',
            'applied-discount': '15% Rabais',
            'net-total': 'Total net',
            vat: 'TVA {{percentage}}%',
            total: 'Total',
            promotion: 'Profiter immédiatement de notre offre promotionnelle',
        },
        'data-collection': {
            dialog: {
                title: 'INDICATION IMPORTANTE POUR LA COLLECTE DES DONNEES:',
                description: {
                    title: "4.2 Dispositions complémentaires pour l'utilisation des services Internet CRB en relation avec les données des utilisateurs",
                    content:
                        "CRB offre aux utilisateurs enregistrés de certains services web la possibilité de se présenter et/ou de présenter leurs projets de même que leurs données de projet à CRB et/ou à d'autres utilisateurs enregistrés de services web par le biais des formulaires intégrés à ces services web. Plusieurs services web CRB comportent une zone d’échange et d’information permettant aux utilisateurs enregistrés de montrer leurs projets et de s’informer au sujet des projets d’autres utilisateurs, de prendre contact avec les autres utilisateurs et d’échanger des informations. L'utilisation des services web de CRB implique en principe une inscription. En s'inscrivant, l'utilisateur peut ajouter des informations sur lui-même ou sur son entreprise et/ou sur ses projets, et parfois également sur les participants au projet. Ces informations doivent être véridiques et correspondre à la réalité, de même que la publication de ces informations doit se faire en accord avec les intéressés et en conformité avec les dispositions légales en matière de protection des données. CRB ne peut assumer aucune responsabilité en la matière et dans le cas où des revendications seraient faites à l'encontre de CRB, l'utilisateur responsable est tenu d'indemniser entièrement et de tenir CRB à l'écart de toute action en justice. CRB se réserve toutefois le droit d'effacer toute information fausse, inadéquate, erronée et incorrecte, sans autre explication et sans en informer l'utilisateur. Le nom d’utilisateur et le mot de passe ouvrant l’accès aux services Internet CRB sont classés secrets et ne doivent en aucun cas être communiqués, en particulier à des tiers non enregistrés. Les informations que l’utilisateur publie dans le cadre des services web CRB, que ce soit à son sujet, au sujet de son entreprise ou de ses projets, peuvent être utilisées sans restriction par CRB pour développer et proposer de nouvelles fonctions ou prestations. En particulier pour les services web qui peuvent être utilisés gratuitement, les informations sur les projets des utilisateurs telles que les données, les maquettes, les descriptifs, les classifications etc., seront rendues anonymes avant d'être réutilisées. Ces informations peuvent selon les besoins être publiées au nom de CRB, et/ou être employées pour la compilation de valeurs et/ou l'analyse statistique puis publiées au nom de CRB. De la même manière, les partenaires mentionnés par l’utilisateur peuvent être invités par CRB à s’inscrire aux services web CRB. L’utilisation des informations et des données fournies par les autres utilisateurs à propos de leurs projets et de leurs partenaires est strictement limitée aux fins d’information et de contact. Toute utilisation dépassant ce cadre requiert au préalable l’autorisation écrite de CRB.",
                },
                cancel: 'OK',
            },
        },
        userdata: {
            title: "Données d'utilisateur",
            email: 'Adresse e-mail',
            password: 'Mot de passe',
            'repeat-password': 'Répéter le mot de passe',
            'immediate-access': "Accès immédiat après l'inscription",
            'after-order': "Une fois inscrit, vous recevrez les codes d'accès à werk-material.online par mail",
            'password-requirements': 'Le mot de passe doit compter au moins {{length}} signes',
        },
        billing: {
            title: 'Facturation',
            salutation: 'Titre',
            company: 'Entreprise',
            firstname: 'Prénom',
            lastname: 'Nom',
            phonenumber: 'Téléphone',
            street: 'Rue',
            postofficebox: 'Case postale',
            postcode: 'NPA',
            city: 'Lieu',
            country: 'Pays',
        },
        'accept-terms': "J'accepte les conditions contractuelles générales",
    },
    login: {
        title: 'Inscrivez-vous',
        'register-link': 'ou créez un compte',
        'forgot-password': 'Mot de passe oublié?',
        'reset-password-instruction':
            "Entrez l'adresse e-mail avec laquelle vous vous êtes inscrit ici, et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    },
    'password-reset': {
        'forgot-password': 'Mot de passe oublié?',
    },
    'create-project': {
        project: 'Créer un projet',
        estimation: 'Calculateur eCCC-Bât',
        name: 'Nom du projet',
        'cost-index': {
            date: 'Niveau de prix',
            'greater-region': 'Grande région',
        },
        'submit-button': 'Créer',
        error: "En raison de l'absence de données sur les prix, les projets du Lichtenstein ne sont pas soutenus.",
    },
    editor: editorTranslations,
    settings: settingsTranslations,
    feedback: {
        title: 'Feedback',
        'submit-feedback': 'Envoyer',
        'thank-you': 'Merci beaucoup pour vos commentaires.',
        personal: {
            title: 'Informations personnelles',
            salutation: 'Titre',
            firstname: 'Prénom',
            lastname: 'Nom',
            email: 'Courriel',
        },
        report: {
            title: 'Feedback',
            topic: 'Thèmes',
            text: 'Texte',
        },
    },
    customerService: {
        title: 'Service clientèle',
        salutation: 'Titre',
        firstname: 'Prénom',
        lastname: 'Nom',
        email: 'Courriel',
        text: 'Texte',
        'submit-customer-service-request': 'Envoyer',
        'thank-you': 'Merci beaucoup pour votre message, nous le traiterons dès que possible.',
    },
    company: {
        'cooperation-partners': 'Partenaires de coopération',
        'customer-service': 'Service à la clientèle',
    },
    account: {
        'change-password': {
            title: 'Modifier le mot de passe',
            instructions: 'Entrez votre ancien mot de passe et choisissez un nouveau mot de passe.',
            'current-password': 'Mot de passe actuel',
            'new-password': 'Nouveau mot de passe',
            'repeat-new-password': 'Répéter le nouveau mot de passe',
            change: 'Changer',
        },
    },
    salutation: {
        male: 'Monsieur',
        female: 'Madame',
    },
    navigation: {
        account: 'Account',
        'change-password': 'Modifier le mot de passe',
        order: 'Sélectionner le(s) produit(s)',
    },
    common: {
        yes: 'Oui',
        no: 'No',
        user: 'Utilisateur',
        username: "Nom d'utilisateur",
        'email-address': 'Adresse e-mail',
        password: 'Mot de passe',
        login: 'Connexion',
        logout: 'Déconnexion',
        remember: 'Rester connecté',
        confirm: 'Confirmer',
        submit: 'Transmission',
        close: 'Fermer',
        'processing-request': 'Traitement de votre demande. Cela peut prendre plusieurs minutes',
        'do-not-reload': 'Merci de ne pas recharger la page et de patienter. Merci beaucoup.',
        'waiting-for-sync': 'Votre commande est en cours de préparation. Merci de patienter un instant.',
        'thank-you': 'Merci!',
        editor: 'Editeur',
        ok: 'OK',
        cancel: 'Annuler',
        continue: 'Continuer',
        back: 'Arrière',
        add: 'Ajouter',
        edit: 'Modifier',
        pagination: {
            page: 'Page',
            next: 'Prochain',
            previous: 'Antérieur',
        },
    },
    errors: {
        'error-title': 'Une erreur est survenue',
        'no-required-roles':
            'Une erreur est malheureusement survenue. Veuillez vous déconnecter et vous reconnecter. Si cela n\'aboutit pas, veuillez contacter CRB à l\'adresse <a href="mailto:support@crb.ch">support@crb.ch</a>.',
        'login-data-wrong': "Le nom d'utilisateur et le mot de passe ne correspondent pas.",
        'service-unavailable': "Le serveur n'a pas pu être joint.",
        'incomplete-form': 'Le formulaire soumis est incomplet, veuillez vérifier à nouveau.',
        'server-failed': 'Le serveur ne peut pas répondre à la demande pour le moment. Réessayez plus tard.',
    },
    export: {
        language: 'Langue',
        success: '{{count}} projet a été exporté avec succès',
        success_plural: '{{count}} projets ont été exportés avec succès',
        failed: "{{count}} projet n'a pas pu être exporté",
        failed_plural: "{{count}} projets n'ont pas pu être exportés",
    },
    import: {
        title: 'Importer des projets',
        text: 'Les fichiers Excel au format correct peuvent être importés ici',
        areaText: 'Cliquez ici ou faites glisser les fichiers sur cette zone',
        success: 'Le projet {{count}} a été importé avec succès',
        success_plural: '{{count}} projets ont été importés avec succès',
        failed: "Le projet {{count}} n'a pas pu être importé",
        failed_plural: "Les projets {{count}} n'ont pas pu être importés",
        error: {
            upload: {
                failed: 'Le téléchargement a échoué',
            },
            import: {
                invalid: {
                    file: 'Format de fichier non valide',
                    lang: 'Langue non valide ou manquante',
                    name: 'Nom manquant',
                    costIndexDate: "Date d'indice de coût non valide ou manquante",
                    greaterRegion: 'Grande région non valide ou manquante',
                    buildingClass: "Type d'installation invalide ou manquant werk-material",
                },
            },
        },
    },
    userinfo: {
        userEmail: 'Email',
        userId: "Identifiant de l'utilisateur",
        copy: {
            click: 'Cliquer pour copier',
            clicked: 'Copié!',
        },
    },
    project: {
        transfer: {
            'dialog-title': 'Transférer le projet',
            'dialog-title_plural': 'Transférez les projets',
            content:
                "Saisissez l'identifiant du destinataire et cliquez sur Transférer.\n\nAprès le transfert, le projet n'apparaîtra plus dans votre liste de projets !",
            content_plural:
                "Saisissez l'identifiant du destinataire et cliquez sur Transférer.\n\nAprès le transfert, les projets ne seront plus affichés dans leur liste de projets !",
            receiverId: 'ID du récepteur',
            cancel: 'Annuler',
            confirm: 'Transfert',
        },
    },
    languages: {
        de: 'Allemand',
        fr: 'Français',
        it: 'Italien',
        en: 'Anglais',
    },
};
